import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { PAGE_ICONS, pageIcon } from './pageIcons';

/**
 * أيقونة القسم. في وضع التعديل بتبقى زرار يفتح قائمة أيقونات.
 * children = شكل الأيقونة (بنمرّرله الـ component بتاعها)
 */
const IconPicker = ({ value, onChange, editing, children }) => {
  const [open, setOpen] = useState(false);
  const Icon = pageIcon(value);

  if (!editing) return Icon ? children(Icon) : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          title="تغيير الأيقونة"
          className="rounded-md outline-dashed outline-1 outline-burgundy-500/40 hover:outline-burgundy-500 outline-offset-2 transition"
        >
          {Icon ? children(Icon) : <span className="block w-6 h-6 text-xs text-gray-400 leading-6">+</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-2" align="start">
        <div className="grid grid-cols-7 gap-1">
          {Object.entries(PAGE_ICONS).map(([name, Item]) => (
            <button
              key={name}
              type="button"
              title={name}
              onClick={() => {
                onChange(name);
                setOpen(false);
              }}
              className={cn(
                'w-8 h-8 inline-flex items-center justify-center rounded-md hover:bg-burgundy-500/10',
                value === name && 'bg-burgundy-500 text-white hover:bg-burgundy-500'
              )}
            >
              <Item className="w-4 h-4" />
            </button>
          ))}
        </div>
        {value && (
          <button
            type="button"
            onClick={() => {
              onChange(null);
              setOpen(false);
            }}
            className="mt-2 w-full text-xs text-gray-500 hover:text-red-600"
          >
            بدون أيقونة
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default IconPicker;
